import { render, staticRenderFns } from "./meetingDetail.vue?vue&type=template&id=89f493de&scoped=true&"
import script from "./meetingDetail.vue?vue&type=script&lang=js&"
export * from "./meetingDetail.vue?vue&type=script&lang=js&"
import style0 from "./meetingDetail.vue?vue&type=style&index=0&id=89f493de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f493de",
  null
  
)

export default component.exports